import { useState } from 'react';
import { FeedbackList } from '@/components/flexhelper/feedback/feedback-list';
import { useToast } from '@/hooks/use-toast';
import type { TaskFeedback } from '@/lib/types';

// Mock feedback data
const mockFeedback: TaskFeedback[] = [
  {
    id: '1',
    rating: 5,
    comment: 'Great work! Very professional and efficient.',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    rating: 4,
    comment: 'Good service, completed the task on time.',
    createdAt: '2024-01-14T15:30:00Z',
  },
];

export function HelperFeedbackPage() {
  const [feedback] = useState(mockFeedback);
  const { toast } = useToast();

  const handleRespondToFeedback = async (feedbackId: string, response: string) => {
    try {
      // Here you would make an API call to respond to the feedback
      console.log('Responding to feedback:', { feedbackId, response });
      
      toast({
        title: 'Success',
        description: 'Response sent successfully',
      });
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Failed to send response',
      });
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">My Feedback</h1>
      <FeedbackList feedback={feedback} />
    </div>
  );
}